import React, {useEffect, useState} from "react";
import {BlueButton} from "../../../component/button";
import Api from '../../../interface/api/file';
import {FileInfo} from "../../../interface/model/file";
import {constructEquipmentInfo, EquipmentInfo} from "../../../interface/model/visitorExtends";

const ButtonStyle = {
    display: 'inline-block',
    height: '33px',
    padding: '0 15px',
    fontSize: '13px',
    lineHeight: '33px',
    verticalAlign: 'middle',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '5px',
    color:'#fff',
    background: '#3280ff'
}

export default function EquipmentInfoComponent({equipmentInfoData, onClickHandler}) {
    const [ modal, setModal ] = useState<boolean>(false);

    return (
        <>
            <BlueButton type={'button'}
                        innerHTML={equipmentInfoData!==undefined && equipmentInfoData!==null ? '수정' : '등록'}
                        onClickHandler={() => setModal(true)}
            />
            {
                modal &&
                    <Modal
                        equipmentInfoData={equipmentInfoData}
                        submitHandler={onClickHandler}
                        closeModal={setModal} />
            }
        </>
    )
}

function Modal({equipmentInfoData, submitHandler, closeModal}) {

    const [ fileInfo, setFileInfo ] = useState<FileInfo>(null);

    function submit(e) {
        e.preventDefault();
        if(fileInfo===null)
            alert('파일을 선택해주세요.')
        else {
            submitHandler({...constructEquipmentInfo, fileInfos:[fileInfo]});
            closeModal(false);
        }
    }

    function deleteFile() {
        Api.deleteFileInfo(fileInfo.seq).then(res => {
            setFileInfo(null);
            submitHandler(null);
        });
    }

    function fileOnChange (e) {
        let fileArray = new Array();
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            if(files[i].size <= 10485760) {
                fileArray.push(files[i]);
            } else {
                alert('10MB 이하의 파일만 업로드 가능합니다.');
                throw 'fileMaxSizeError';
            }
        }
        Api.createFileInfo('EQUIPMENT', fileArray).then(res => setFileInfo(res.data));
    }

    useEffect(() => {
        // if(equipmentInfoData!==null && equipmentInfoData.length > 0)
        if(equipmentInfoData!==undefined && equipmentInfoData!==null)
            setFileInfo(equipmentInfoData.fileInfos[0]);
    }, [])

    return (
        <div className="nv_modal nv_modal1 on">
            <div className="nv_modal_container">
                <div className="nv_modal_header">
                    <h2 id="find-host-title">중장비 서류 첨부</h2>
                    <p className="nv_modal_close" onClick={() => closeModal(false)}>닫기</p>
                </div>
                <form onSubmit={submit}>
                    <div className="nv_modal_contents" style={{padding: '5px 15px'}}>
                        <table className="nv_table">
                            <colgroup>
                                <col width={'70%'}/>
                                <col width={'30%'}/>
                            </colgroup>
                            <thead>
                            <tr>
                                <th scope="row">첨부파일</th>
                                <th scope="row">관리</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                fileInfo === null
                                    ? <tr>
                                        <td>
                                        </td>
                                        <td>
                                            <input type="file"
                                                   id="insertFile"
                                                   style={{display: "none"}}
                                                   onChange={fileOnChange}
                                                   required={true}
                                                   multiple/>
                                            <label htmlFor="insertFile" style={ButtonStyle}>
                                                파일선택
                                            </label>
                                        </td>
                                    </tr>
                                    : <tr>
                                        <td>{fileInfo.fileName}</td>
                                        <td>
                                            <button type="button"
                                                    className="nv_button_red minus"
                                                    onClick={deleteFile}>삭제
                                            </button>
                                        </td>
                                    </tr>
                            }

                            </tbody>
                        </table>
                        <p style={{color: 'red'}}>* 첨부파일은 10MB 이하의 파일만 등록이 가능합니다.</p>
                    </div>
                    <div className="nv_btn_area" style={{textAlign: 'center', margin:'10px 0px'}}>
                        <button type="submit" className="nv_btn_blue" style={{marginTop:0}}>저장</button>
                    </div>
                </form>
            </div>
        </div>
    )
}